module.exports = __webpack_public_path__ + "img/client_icon_02_en.42d505b7.png";